import { Component } from '@angular/core';

@Component({
  selector: 'app-services-section2',
  templateUrl: './services-section2.component.html',
  styleUrls: ['./services-section2.component.scss']
})
export class ServicesSection2Component {}
